import { useState } from "react";
import { observer } from "mobx-react";
import { utilsStore } from "../../../../platform/stores";
import { useTranslation } from "../../../../platform/stores/translationStore";
import gift from '../../../../assets/icons/gift.svg';
import '../free-bet.scss';

export const FreeBetAwardModal = observer(() => {
  const { freeBetAwardData, setFreeBetAwardData } = utilsStore;
  const [closing, setClosing] = useState(false);
  const t = useTranslation();

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setFreeBetAwardData(undefined);
      setClosing(false);
    }, 250);
  };

  if (!freeBetAwardData) return null;

  return (
    <div className={`free-bet-overlay${closing ? ' closing' : ''}`}>
      <div className="free-bet-backdrop" onClick={handleClose} />
      <div className={`free-bet-card${closing ? ' closing' : ''}`}>
        <button className="close-btn" onClick={handleClose} aria-label={t('FREE_BET_CLOSE')}>✕</button>

        <div className="free-bet-icon-wrapper">
          <img src={gift} alt={t('FREE_BET_ICON_GIFT_ALT')} />
        </div>

        <div className="free-bet-badge">{t('FREE_BET_BADGE')}</div>

        <h2>{t('FREE_BET_AWARD_CONGRATULATIONS')}</h2>

        <h3>
          {t('FREE_BET_AWARD_YOU_GET', freeBetAwardData.quantity)}<br />
          {t('FREE_BET_AWARD_GOOD_LUCK')}
        </h3>

        <div className="free-bet-divider" />

        <button className="free-bet-btn" onClick={handleClose}>
          {t('FREE_BET_AWARD_PLAY_NOW')}
        </button>
      </div>
    </div>
  );
});
